import * as React from "react";

import MarkerImg from "../../assets/markers/pin3.png";
import { Marker } from "react-map-gl";


import axios from "axios";

export default function GoPlayMap(props) {

  // Setting the map position on marker select
  const setMapPosition = (result) =>{
    let markerLng = result.coordinates[0];
    let markerLat = result.coordinates[1];

    let east = props.mapRef.current.getBounds()._ne.lng;
    let west = props.mapRef.current.getBounds()._sw.lng;
    let width = east - west;

    let north = props.mapRef.current.getBounds()._ne.lat;
    let south = props.mapRef.current.getBounds()._sw.lat;
    let height = north - south;

    let flyToLng = (((markerLng + (width / 9)) + 90) % 180) - 90;
    let flyToLat = (((markerLat - (height / 2.2)) + 90) % 180) - 90;
    props.mapRef.current.flyTo({ center: [flyToLng, flyToLat] })
  }

  // Fetch event details upon marker selection
  React.useEffect(() => {

    // Fetch event details
    const fetchEventDetail = (event_id) => {
      axios.get(`${process.env.REACT_APP_API_URL}events/${event_id}`)
        .then((response) => {
          const responseEventDetail = response.data;
          props.setEventDetail(responseEventDetail);
          props.setLoadingEventDetail(false);
        });
    };

    props.selectedEvent && fetchEventDetail(props.selectedEvent.id);
  }, [props]);


  return (
    <>
      <div>
      {/*GoPlay Event Markers*/}

        {props.events &&
          props.events.map((unifyEvent) => {
            return (
              <Marker
                key={unifyEvent.id}
                latitude={unifyEvent.coordinates[1]}
                longitude={unifyEvent.coordinates[0]}
                anchor="bottom"
              >
                <button
                  type="button"
                  className="marker-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setLoadingEventDetail(true);
                    props.setSelectedEvent(unifyEvent);
                    setMapPosition(unifyEvent)
                    
                  }}
                >
                <img src={MarkerImg} alt="Event" />
                </button>
              </Marker>
            );
          })}
      </div>
    </>
  );
}
